// MessageId.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import MongoObjectIdMatcher from '../component/MongoObjectIdMatcher.jsx';
import UniversalComponent from '../component/UniversalComponent.jsx';
import { EMPTY_ARRAY } from '../resource/defaults.js';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const MessageIdRoute = () => {
  const { meta = EMPTY_ARRAY } = useLoaderData();

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <MongoObjectIdMatcher paramKeys={['messageId']}>
        <UniversalComponent
          filename="Container_StoryMessage"
          shouldLoop={true}
          importer={
            /* #__LOADABLE__ */ () => import('../container/StoryMessage.js')
          }
        />
      </MongoObjectIdMatcher>
    </>
  );
};

export default MessageIdRoute;
